import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AccountSettingsService } from '@services/accountSettings/account-settings.service';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class AccountSettingsGuardService {

  constructor(private accountSettingsService: AccountSettingsService, private router: Router) {
  }


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return true;
  }
}
